import { IApiResponse } from "../../../@types/api-response.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const startProjectImport = async (type: number) : Promise<IApiResponse<void> | ApiException> => {
    try {
        const { data } = await Api.post<IApiResponse<void>>(`/api/ProjectImport/StartProjectImport`, type);
        return data
    } catch (error) {
        throw new ApiException(getErrorMessage(error, 'Erro ao importar Projetos'))
    }
}
